// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3J-Dt","range":"MonthRangeSwitch_range__3o0LV","disabled":"MonthRangeSwitch_disabled__2JmYs"};